import React from 'react';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { setSearchTerm } from '@repo/redux/actions/search';
import { Section, SectionTitle } from '@repo/components/containers';
import styles from './Tips.module.scss';
import { ArrowRightIcon, CircledIIcon } from '@repo/icons';
import analytics from '@repo/utils/helpers/analytics';
import { useSearchTips } from '@repo/hooks';
import { openModal } from '@repo/redux/actions/ui';

export const SearchTerm = ({ className, term }: { className?: string; term: string }) => {
  const dispatch = useDispatch();

  const handleSearch = (term) => {
    analytics.track('Query Example Tapped');
    dispatch(setSearchTerm(term.toLowerCase(), true));
  };

  return (
    <span
      className={cn(styles.example, 'text-small', className)}
      onClick={() => handleSearch(term)}
    >
      {term}
    </span>
  );
};

const TipsIcon = (props) => (
  <CircledIIcon {...props} color="textSecondary" width={13} height={13} />
);

export const SearchTips = ({ className }: { className?: string }) => {
  const dispatch = useDispatch();
  const searchTips = useSearchTips();

  const applySearchTerm = (term) => {
    analytics.track('Query Example Tapped');
    dispatch(setSearchTerm(term.toLowerCase(), true));
  };

  return (
    <Section className={cn(styles.tipsContainer, className)}>
      <SectionTitle className={styles.title} listItem IconComponent={TipsIcon}>
        Search Tips
      </SectionTitle>
      <div className={styles.tipsList}>
        {searchTips.selection.map((tip, idx) => (
          <button key={idx} className={styles.tipBtn} onClick={() => applySearchTerm(tip.term)}>
            <div className={styles.tipTerm}>{tip.term}</div>
            <span className={styles.tipDescription}>{tip.description}</span>
          </button>
        ))}
      </div>
      <button className={styles.exploreBtn} onClick={() => dispatch(openModal('searchEducation'))}>
        Explore all search terms
        <ArrowRightIcon color="textPrimary" />
      </button>
    </Section>
  );
};
